// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,...", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KlpfTHqSifP_u3hcL60v {
    display: flex;
    flex-direction: column;
    position: relative;
    /* margin-bottom: 32px;  */
    width: 100%;
}


.KlpfTHqSifP_u3hcL60v:hover .U5jLn3WZrO7Mymsndgxe {
    border-color: var(--blue); 
}

.KlpfTHqSifP_u3hcL60v:hover .DcV1RqPb7dCDjW2m916n {
    color: var(--blue); 
}

.U5jLn3WZrO7Mymsndgxe:focus {
    border-color: var(--blue);
    border-width: 1px;
    padding-left: 15px; 
}

.U5jLn3WZrO7Mymsndgxe:focus + .iA2IObfpRwz3s98KfZMX {
    stroke: var(--blue);
}

.U5jLn3WZrO7Mymsndgxe:disabled {
    cursor: default;
    opacity: 0.6;
    color: var(--black)
}

.UhgQMf8Wl0iTKrHFd9Jw {
    position: relative;
    width: 100%;
    margin-top: 8px;
}

.U5jLn3WZrO7Mymsndgxe {
    width: 100%;
    height: 48px;
    padding: 0 14px;
    font-family: inherit;
    font-size: 14px;
    background-color: var(--white);
    border: 1px solid var(--disabled-c);
    border-radius: 10px;
    cursor: pointer;
    appearance: none;
    outline: none;
    text-align: left;
    transition: border-color 200ms, border-width 50ms;
}

.DcV1RqPb7dCDjW2m916n {
    position: absolute;
    left: 10px;
    top: -8px;
    padding: 0 4px;
    font-size: 14px;
    color:var(--disabled-c);
    background-color: var(--white); /* ВАЖЛИВО: має збігатися з фоном сторінки */
    pointer-events: none;
    transition: color 200ms;
    font-weight: 500;
}

.UhgQMf8Wl0iTKrHFd9Jw:hover .U5jLn3WZrO7Mymsndgxe {
    border-color: var(--blue);
}

.UhgQMf8Wl0iTKrHFd9Jw:hover .DcV1RqPb7dCDjW2m916n {
    color: var(--blue);
}

.U5jLn3WZrO7Mymsndgxe:focus {
    border-color: var(--blue);
    border-width: 1px;
    padding: 0 13px; 
}

.U5jLn3WZrO7Mymsndgxe:focus + .DcV1RqPb7dCDjW2m916n {
    color: var(--blue);
}

.iA2IObfpRwz3s98KfZMX {
    position: absolute;
    right: 14px;
    top: 50%;
    transform: translateY(-50%);
    width: 12px;
    height: 8px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* твоя SVG */
    background-repeat: no-repeat;
    pointer-events: none;
}

._0Zo0ugilw_lJ9ovcfUQH {
    position: absolute;
    /* top: calc(100% + 5px); */
    left: 0;
  right: 0;
    width: 100%;
    background-color: var(--background);
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    z-index: 10;
    padding: 5px;
    list-style: none;
    max-height: 250px;
    overflow-y: auto;
}

.xq3ENxiEYkqxhJNHj9ZB {
    transform: translateY(-50%) rotate(180deg) !important;
}

._0Zo0ugilw_lJ9ovcfUQH::-webkit-scrollbar {
    width: 2px;
}
._0Zo0ugilw_lJ9ovcfUQH::-webkit-scrollbar-thumb {
    border-radius: 20px;
}
._0Zo0ugilw_lJ9ovcfUQH {
    position: absolute;
    top: calc(100% + 5px);
    left: 0;
    width: 100%;
    background-color: var(--white);
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    z-index: 100;
    
    padding: 5px 4px 5px 5px; 
    max-height: 250px;
    overflow-y: auto;
    
    /* 2. Ховаємо стандартний фон треку, щоб він не виходив за заокруглення */
    scrollbar-color: var(--blue) transparent;
}

._0Zo0ugilw_lJ9ovcfUQH::-webkit-scrollbar-track {
    background: transparent; 
    margin: 8px 0; 
}

._0Zo0ugilw_lJ9ovcfUQH::-webkit-scrollbar-thumb {
    background-color: var(--disabled-bg);
    border-radius: 20px;
    transition: background-color 0.2s ease;
}

._0Zo0ugilw_lJ9ovcfUQH::-webkit-scrollbar-thumb:hover {
    background-color: var(--dark-gray);
}
._0Zo0ugilw_lJ9ovcfUQH::-webkit-scrollbar {
    width: 2px; 
}


.XX5tczCK2OimtHFn4yPX {
    text-align: left;
    padding: 12px 15px;
    color: var(--black);
    width: 100%;
    font-size: 14px; 
    line-height: 1.4;
    background-color: transparent;
    border: none;
    cursor: pointer;
    border-radius: 8px; 
    transition: background-color 0.2s ease, color 0.2s ease;
}

.XX5tczCK2OimtHFn4yPX:hover {
    background-color: var(--sidebar-hover);
    color: var(--blue); 
}

.XX5tczCK2OimtHFn4yPX.j6SA7J76GUal_VBkT0AQ {
    background-color: rgba(24, 96, 217, 0.12);
    color: var(--blue);
    font-weight: 600;
}
.U5jLn3WZrO7Mymsndgxe::placeholder {
    color: var(--disabled-c); 
    opacity: 0.6;
    font-size: 13px;
}

.U5jLn3WZrO7Mymsndgxe:hover .fsGLmfZVZJi9QDdhEB6Z {
    color: var(--black);
    transition: color 0.2s ease;
}
.VlmfvXuklAVAv_3uYHRA {
    /* border-color: var(--disabled-c) !important; */
}

/* --------- */




.z4A_7U4q5eQWYB9K3nMh {
  border: 1px solid  var(--vivid-pink) !important; /* Червона рамка */
}

.tYEXClqn2aGEQSg4Z_T1 {
  color:  var(--vivid-pink);
  font-size: 10px;
  margin-top: -12px;
  margin-left: 12px;
  display: block;
  height: 1px;
}

.uUKlJrQvwc3iNI0RdkUw {
  display: flex;
  flex-direction: column;
  gap: 12px;

}

/* .container {
  display: flex;
  flex-direction: column;
  gap: 16px;
      max-width: 30vw;

} */

.YDCuuTl2KvKhsRc_9RnD {
  display: grid;
  /* grid-template-rows: repeat(7, auto);  */
 /* grid-template-columns: repeat(2, 28vw);   */
  grid-template-rows: repeat(1, 1fr); 
   grid-auto-flow: row;  
  gap: 15px 40px; 
    align-items: start;
}
@media screen and (max-width: 767px) {
.YDCuuTl2KvKhsRc_9RnD {
  display: grid;
  /* grid-template-rows: repeat(7, auto);  */
grid-template-columns: repeat(1, calc(100% - 20px)); 
  grid-auto-flow: column; 
  gap: 15px 40px; 
    align-items: start;
}

}

@media (max-width: 600px) {
  .YDCuuTl2KvKhsRc_9RnD {
    grid-template-rows: none;
    grid-auto-flow: row;
  }
}

._8eDQEMKa6LpevUcWjatg {
  display: flex;
  align-items: center;
  gap: 8px;
      position: relative;

}


.vwyAzvSOEzl60mkNJnzg {
  border: none; 
  color: var(--blue);
  padding: 10px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px; 
  text-decoration: underline dotted transparent;
  text-underline-offset: 3px;
  transition: text-decoration-color 0.2s ease;
  width: max-content;
}

.vwyAzvSOEzl60mkNJnzg:hover {
  text-decoration-color: rgba(0, 102, 255, 0.5);
}
.VjGzNaHh4vISy0_lu30w {
  color: var(--disabled-c);
  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
  padding: 0 5px;
    position: absolute;
    right: 8px; 
    height: 48px;

}
.VjGzNaHh4vISy0_lu30w:hover {
  color: var(--vivid-pink);
}


.pvS_dGgNjGp_SFv6WwY4 {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: var(--blue);
    position: relative;

    svg {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
}
.E478JLrdgNQ_NU1HLuSb {
  color: var(--disabled-c);
  cursor: not-allowed;
  background-color: #fafafa;
  pointer-events: none; /* Це повністю вимкне кліки */
}

.F_Tywsvqe2GZ5pAA9Uw8 {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 10px;
}

@media (max-width: 768px) {
  .F_Tywsvqe2GZ5pAA9Uw8 {
    flex-direction: column; 
    align-items: flex-start; 
    gap: 15px;
  }
  
  .F_Tywsvqe2GZ5pAA9Uw8 > div, 
  .F_Tywsvqe2GZ5pAA9Uw8 > input,
  .F_Tywsvqe2GZ5pAA9Uw8 > button {
    width: 100% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Select.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,0BAA0B;IAC1B,WAAW;AACf;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,8BAA8B;IAC9B,mCAAmC;IACnC,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,iDAAiD;AACrD;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,cAAc;IACd,eAAe;IACf,uBAAuB;IACvB,8BAA8B,EAAE,4CAA4C;IAC5E,oBAAoB;IACpB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,WAAW;IACX,yDAA+C,EAAE,aAAa;IAC9D,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,OAAO;EACT,QAAQ;IACN,WAAW;IACX,mCAAmC;IACnC,oCAAoC;IACpC,mBAAmB;IACnB,yCAAyC;IACzC,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,UAAU;AACd;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,WAAW;IACX,8BAA8B;IAC9B,oCAAoC;IACpC,mBAAmB;IACnB,yCAAyC;IACzC,YAAY;;IAEZ,wBAAwB;IACxB,iBAAiB;IACjB,gBAAgB;;IAEhB,yEAAyE;IACzE,wCAAwC;AAC5C;;AAEA;IACI,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;IACI,kCAAkC;AACtC;AACA;IACI,UAAU;AACd;;;AAGA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,uDAAuD;AAC3D;;AAEA;IACI,sCAAsC;IACtC,kBAAkB;AACtB;;AAEA;IACI,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,wBAAwB;IACxB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;AACA;IACI,gDAAgD;AACpD;;AAEA,cAAc;;;;;AAKd;EACE,+CAA+C,EAAE,kBAAkB;AACrE;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;;AAEX;;AAEA;;;;;;GAMG;;AAEH;EACE,aAAa;EACb,0CAA0C;CAC3C,8CAA8C;EAC7C,kCAAkC;GACjC,mBAAmB;EACpB,cAAc;IACZ,kBAAkB;AACtB;AACA;AACA;EACE,aAAa;EACb,0CAA0C;AAC5C,mDAAmD;EACjD,sBAAsB;EACtB,cAAc;IACZ,kBAAkB;AACtB;;AAEA;;AAEA;EACE;IACE,wBAAwB;IACxB,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;MACJ,kBAAkB;;AAExB;;;AAGA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,6CAA6C;EAC7C,0BAA0B;EAC1B,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;AAC/C;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;;AAEhB;AACA;EACE,wBAAwB;AAC1B;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,kBAAkB;;IAElB;QACI,kBAAkB;QAClB,SAAS;QACT,QAAQ;QACR,gCAAgC;IACpC;AACJ;AACA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB,EAAE,6BAA6B;AACrD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;;;IAGE,sBAAsB;EACxB;AACF","sourcesContent":[".formControl {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    /* margin-bottom: 32px;  */\n    width: 100%;\n}\n\n\n.formControl:hover .select {\n    border-color: var(--blue); \n}\n\n.formControl:hover .label {\n    color: var(--blue); \n}\n\n.select:focus {\n    border-color: var(--blue);\n    border-width: 1px;\n    padding-left: 15px; \n}\n\n.select:focus + .arrowIcon {\n    stroke: var(--blue);\n}\n\n.select:disabled {\n    cursor: default;\n    opacity: 0.6;\n    color: var(--black)\n}\n\n.selectWrapper {\n    position: relative;\n    width: 100%;\n    margin-top: 8px;\n}\n\n.select {\n    width: 100%;\n    height: 48px;\n    padding: 0 14px;\n    font-family: inherit;\n    font-size: 14px;\n    background-color: var(--white);\n    border: 1px solid var(--disabled-c);\n    border-radius: 10px;\n    cursor: pointer;\n    appearance: none;\n    outline: none;\n    text-align: left;\n    transition: border-color 200ms, border-width 50ms;\n}\n\n.label {\n    position: absolute;\n    left: 10px;\n    top: -8px;\n    padding: 0 4px;\n    font-size: 14px;\n    color:var(--disabled-c);\n    background-color: var(--white); /* ВАЖЛИВО: має збігатися з фоном сторінки */\n    pointer-events: none;\n    transition: color 200ms;\n    font-weight: 500;\n}\n\n.selectWrapper:hover .select {\n    border-color: var(--blue);\n}\n\n.selectWrapper:hover .label {\n    color: var(--blue);\n}\n\n.select:focus {\n    border-color: var(--blue);\n    border-width: 1px;\n    padding: 0 13px; \n}\n\n.select:focus + .label {\n    color: var(--blue);\n}\n\n.arrowIcon {\n    position: absolute;\n    right: 14px;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 12px;\n    height: 8px;\n    background-image: url(\"data:image/svg+xml,...\"); /* твоя SVG */\n    background-repeat: no-repeat;\n    pointer-events: none;\n}\n\n.dropdown {\n    position: absolute;\n    /* top: calc(100% + 5px); */\n    left: 0;\n  right: 0;\n    width: 100%;\n    background-color: var(--background);\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    border-radius: 10px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n    z-index: 10;\n    padding: 5px;\n    list-style: none;\n    max-height: 250px;\n    overflow-y: auto;\n}\n\n.rotate {\n    transform: translateY(-50%) rotate(180deg) !important;\n}\n\n.dropdown::-webkit-scrollbar {\n    width: 2px;\n}\n.dropdown::-webkit-scrollbar-thumb {\n    border-radius: 20px;\n}\n.dropdown {\n    position: absolute;\n    top: calc(100% + 5px);\n    left: 0;\n    width: 100%;\n    background-color: var(--white);\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    border-radius: 10px;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n    z-index: 100;\n    \n    padding: 5px 4px 5px 5px; \n    max-height: 250px;\n    overflow-y: auto;\n    \n    /* 2. Ховаємо стандартний фон треку, щоб він не виходив за заокруглення */\n    scrollbar-color: var(--blue) transparent;\n}\n\n.dropdown::-webkit-scrollbar-track {\n    background: transparent; \n    margin: 8px 0; \n}\n\n.dropdown::-webkit-scrollbar-thumb {\n    background-color: var(--disabled-bg);\n    border-radius: 20px;\n    transition: background-color 0.2s ease;\n}\n\n.dropdown::-webkit-scrollbar-thumb:hover {\n    background-color: var(--dark-gray);\n}\n.dropdown::-webkit-scrollbar {\n    width: 2px; \n}\n\n\n.account_btn {\n    text-align: left;\n    padding: 12px 15px;\n    color: var(--black);\n    width: 100%;\n    font-size: 14px; \n    line-height: 1.4;\n    background-color: transparent;\n    border: none;\n    cursor: pointer;\n    border-radius: 8px; \n    transition: background-color 0.2s ease, color 0.2s ease;\n}\n\n.account_btn:hover {\n    background-color: var(--sidebar-hover);\n    color: var(--blue); \n}\n\n.account_btn.selected {\n    background-color: rgba(24, 96, 217, 0.12);\n    color: var(--blue);\n    font-weight: 600;\n}\n.select::placeholder {\n    color: var(--disabled-c); \n    opacity: 0.6;\n    font-size: 13px;\n}\n\n.select:hover .placeholder {\n    color: var(--black);\n    transition: color 0.2s ease;\n}\n.checkedWrapper {\n    /* border-color: var(--disabled-c) !important; */\n}\n\n/* --------- */\n\n\n\n\n.errorRow {\n  border: 1px solid  var(--vivid-pink) !important; /* Червона рамка */\n}\n\n.errorText {\n  color:  var(--vivid-pink);\n  font-size: 10px;\n  margin-top: -12px;\n  margin-left: 12px;\n  display: block;\n  height: 1px;\n}\n\n.rowGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n\n}\n\n/* .container {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n      max-width: 30vw;\n\n} */\n\n.container {\n  display: grid;\n  /* grid-template-rows: repeat(7, auto);  */\n /* grid-template-columns: repeat(2, 28vw);   */\n  grid-template-rows: repeat(1, 1fr); \n   grid-auto-flow: row;  \n  gap: 15px 40px; \n    align-items: start;\n}\n@media screen and (max-width: 767px) {\n.container {\n  display: grid;\n  /* grid-template-rows: repeat(7, auto);  */\ngrid-template-columns: repeat(1, calc(100% - 20px)); \n  grid-auto-flow: column; \n  gap: 15px 40px; \n    align-items: start;\n}\n\n}\n\n@media (max-width: 600px) {\n  .container {\n    grid-template-rows: none;\n    grid-auto-flow: row;\n  }\n}\n\n.row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n      position: relative;\n\n}\n\n\n.addBtn {\n  border: none; \n  color: var(--blue);\n  padding: 10px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px; \n  text-decoration: underline dotted transparent;\n  text-underline-offset: 3px;\n  transition: text-decoration-color 0.2s ease;\n  width: max-content;\n}\n\n.addBtn:hover {\n  text-decoration-color: rgba(0, 102, 255, 0.5);\n}\n.deleteBtn {\n  color: var(--disabled-c);\n  background: none;\n  border: none;\n  font-size: 22px;\n  cursor: pointer;\n  padding: 0 5px;\n    position: absolute;\n    right: 8px; \n    height: 48px;\n\n}\n.deleteBtn:hover {\n  color: var(--vivid-pink);\n}\n\n\n.plusIcon {\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    background-color: var(--blue);\n    position: relative;\n\n    svg {\n        position: absolute;\n        left: 50%;\n        top: 50%;\n        transform: translate(-50%, -50%);\n    }\n}\n.disabled_option {\n  color: var(--disabled-c);\n  cursor: not-allowed;\n  background-color: #fafafa;\n  pointer-events: none; /* Це повністю вимкне кліки */\n}\n\n.doc_type_page_list {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n@media (max-width: 768px) {\n  .doc_type_page_list {\n    flex-direction: column; \n    align-items: flex-start; \n    gap: 15px;\n  }\n  \n  .doc_type_page_list > div, \n  .doc_type_page_list > input,\n  .doc_type_page_list > button {\n    width: 100% !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formControl": `KlpfTHqSifP_u3hcL60v`,
	"select": `U5jLn3WZrO7Mymsndgxe`,
	"label": `DcV1RqPb7dCDjW2m916n`,
	"arrowIcon": `iA2IObfpRwz3s98KfZMX`,
	"selectWrapper": `UhgQMf8Wl0iTKrHFd9Jw`,
	"dropdown": `_0Zo0ugilw_lJ9ovcfUQH`,
	"rotate": `xq3ENxiEYkqxhJNHj9ZB`,
	"account_btn": `XX5tczCK2OimtHFn4yPX`,
	"selected": `j6SA7J76GUal_VBkT0AQ`,
	"placeholder": `fsGLmfZVZJi9QDdhEB6Z`,
	"checkedWrapper": `VlmfvXuklAVAv_3uYHRA`,
	"errorRow": `z4A_7U4q5eQWYB9K3nMh`,
	"errorText": `tYEXClqn2aGEQSg4Z_T1`,
	"rowGroup": `uUKlJrQvwc3iNI0RdkUw`,
	"container": `YDCuuTl2KvKhsRc_9RnD`,
	"row": `_8eDQEMKa6LpevUcWjatg`,
	"addBtn": `vwyAzvSOEzl60mkNJnzg`,
	"deleteBtn": `VjGzNaHh4vISy0_lu30w`,
	"plusIcon": `pvS_dGgNjGp_SFv6WwY4`,
	"disabled_option": `E478JLrdgNQ_NU1HLuSb`,
	"doc_type_page_list": `F_Tywsvqe2GZ5pAA9Uw8`
};
export default ___CSS_LOADER_EXPORT___;
